import BulkUpdatePayoutHold from "../../../views/BulkUpdatePayoutHold";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const bulkUpdatePayoutHoldRoutes = [
  {
    menuName: MenuNames.BULK_UPDATE_PAYOUT_HOLD,
    path: "/bulk-update-payout-hold",
    component: BulkUpdatePayoutHold,
    exact: true,
  },
];

export default bulkUpdatePayoutHoldRoutes;
